module.exports = __webpack_public_path__ + "static/img/file2.0c4edeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/file2.png
// module id = /ttj
// module chunks = 1